import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IUnitsAttribute, ISaveDeleteResponse, INameExists, ICodeExists, IImageModel } from '../Shared/interface';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import {AppService} from './app.service';

@Injectable({
    providedIn: 'root',
})

export class UnitsAttributesService {

    private baseURL = this.appService.config.apiBaseUrl;
    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    getAttributesList(): Observable<IUnitsAttribute[]> {
        return this.http.get<IUnitsAttribute[]>(
            `${this.baseURL}/attribute/GetAttributes`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const attributes = res.body as IUnitsAttribute[];
                    return attributes;
                }),
                catchError(this.handleError)
            );
    }

    getAttributesListForOp(): Observable<IUnitsAttribute[]> {
        return this.http.get<IUnitsAttribute[]>(
            `${this.baseURL}/attribute/GetAttributesForOp`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const attributes = res.body as IUnitsAttribute[];
                    return attributes;
                }),
                catchError(this.handleError)
            );
    }

    getAttributeDetail(id: number): Observable<IUnitsAttribute> {
        return this.http.get<IUnitsAttribute>(
            `${this.baseURL}/attribute/GetAttributeDetails?attributeId=${id}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Detail = res.body as IUnitsAttribute;
                    return Detail;
                }),
                catchError(this.handleError)
            );
    }

    getAllAttributeImages(): Observable<IImageModel[]> {
        return this.http.get<IImageModel[]>(
            `${this.baseURL}/attribute/GetAllAttributeImages`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const images = res.body as IImageModel[];
                    return images;
                }),
                catchError(this.handleError)
            );
    }

    getIsAttributeCodeExist(Code: string): Observable<ICodeExists> {
        return this.http.get<any>(
            `${this.baseURL}/attribute/AttributeCodeExists?attributeCode=${Code}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const CodeExist = result.body as ICodeExists;
                    return CodeExist;
                }),
                catchError(this.handleError)
            );
    }

    getIsAttributeNameExist(Name: string): Observable<INameExists> {
        return this.http.get<INameExists>(
            `${this.baseURL}/attribute/AttributeNameExists?attributeName=${Name}`,
            { observe: 'response' })
            .pipe(
                map(result => {
                    const NameExist = result.body as INameExists;
                    return NameExist;
                }),
                catchError(this.handleError)
            );
    }

    saveAttribute(attribute: IUnitsAttribute): Observable<boolean> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = '';
        if (attribute.Id === 0) {
            url = `${this.baseURL}/attribute/CreateAttribute`;
        } else {
            url = `${this.baseURL}/attribute/UpdateAttribute`;
        }
        return this.http.post<ISaveDeleteResponse>(url, attribute, options)
            .pipe(
                map(res => {
                    return res.Success;
                }),
                catchError(this.handleError)
            );
    }

    deleteAttribute(Id: number) {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<any>(`${this.baseURL}/attribute/DeleteAttribute?attributeId=${Id}`, options);
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
